import { StyleFn } from './index'

export type StylesKeys = 'slider'

export type StylesObj = {
  [key in StylesKeys]?: StyleFn
}

export type Styles = {
  slider: StyleFn
}

export const defaultStyles: Styles = {
  slider: () => ({
    WebkitAppearance: 'none',
    width: '100%',
    background: 'transparent',
    '&::-webkit-slider-thumb': {
      WebkitAppearance: 'none',
      marginTop: -4,
      ...thumbStyles,
    },
    '&::-moz-range-thumb': thumbStyles,
    '&::-ms-thumb': thumbStyles,
    '&::-webkit-slider-runnable-track': {
      WebkitAppearance: 'none',
      ...trackSharedStyles,
      ...trackStyles,
    },
    '&:focus::-webkit-slider-runnable-track': {
      ...trackStyles,
    },
    '&::-moz-range-track': {
      ...trackSharedStyles,
      ...trackStyles,
    },
    '&::-moz-range-progress': {
      ...trackProgressStyles,
    },
    '&::-ms-track': {
      ...trackSharedStyles,
      background: 'transparent',
      borderColor: 'transparent',
      borderWidth: '16px 0',
      color: 'transparent',
    },
    '&::-ms-fill-lower': {
      ...trackStyles,
      background: 'var(--rw-accent, lime)',
    },
    '&::focus::-ms-fill-lower': {
      background: 'var(--rw-accent, lime)',
    },
    '&::-ms-fill-upper': {
      ...trackStyles,
    },
    '&:focus::-ms-fill-upper': {
      background: '#ededed',
    },
    '&:focus': {
      outline: 'none',
    },
  }),
}

const thumbStyles = {
  height: 13,
  width: 13,
  borderRadius: 40,
  background: 'var(--rw-accent, lime)',
  cursor: 'pointer',
  border: 0,
}

const trackSharedStyles = {
  width: '100%',
  height: 5,
  cursor: 'pointer',
}

const trackStyles = {
  boxShadow: '0 1px 0 0 rgba(18,18,19,.05) inset',
  borderRadius: 5,
  border: 0,
  background:
    'linear-gradient(var(--rw-accent, lime), var(--rw-accent, lime)) 0/var(--sx) 100% no-repeat #ededed',
}

const trackProgressStyles = {
  background: 'var(--rw-accent, lime)',
  height: 5,
  borderTopLeftRadius: 5,
  borderBottomLeftRadius: 5,
}
